import useCubeItems, { PageType } from '../hooks/useCubeItems/useCubeItems'
import CubePageTemplate from '../CubePageTemplate/CubePageTemplate'

const Home = ({ gender = null }) => {
  // const items = useCubeItems(PageType.HOME)

  // return <CubePageTemplate items={items} showPopup />

  const items = useCubeItems(PageType.PARTEITAG)

  return <CubePageTemplate items={items} showVideoPopup gender={gender} />
}

export default Home
